/**
 * A card must be backed by a complete query, rather than a select-list
 * expression that happened to appear in an answer or evidence payload.
 * This is an affordance guard; warehouse dry-run remains authoritative.
 */
export function isExecutableLensSql(value: string): boolean {
  const statement = value.replace(/^\s*(?:(?:--[^\n]*(?:\n|$))|(?:\/\*[\s\S]*?\*\/))\s*/g, '').trim();

  if (/^(?:select|with)\b/i.test(statement)) {
    return true;
  }

  return /^(?:declare|create\s+temp(?:orary)?\s+function)\b/i.test(statement) && /\bselect\b/i.test(statement);
}
